// Lineup.jsx
import React, { useState } from 'react';
import './Lineup.css';
import leftDecoration from '../assests/Orchid n Fungi Pillar (3).png';
import rightDecoration from '../assests/Orchid n Fungi Pillar (4).png';
import artistImage from '../assests/Untitled design (17).png';
import lineupIcon from '../assests/Layer_1.png';
import vectorIcon from '../assests/Vector.png';
import ContactModal from '../components/ContactModal';

const Lineup = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <section className="lineup-section" aria-label="Artists lineup for The Hills Festival 2024">
        {/* Access Lineup Header */}
      <div className="lineup-header">
        <img src={lineupIcon} alt="The Hills Festival lineup icon" className="lineup-icon" />
        <i className="fas fa-flower-lineup-icon" aria-hidden="true"></i> ARTISTS LINEUP(2024)
      </div>

      {/* Decorative Flowers */}
      <img src={leftDecoration} alt="" className="flower-decoration left" aria-hidden="true" />
      <img src={rightDecoration} alt="" className="flower-decoration right" aria-hidden="true" />

      
      {/* Artist Lineup List */}
      <article className="artists-lineup">
        <p>
          <span className="stage">Hills Main Stage(2024)</span>
          <br />
          I BUILT THE SKY (AUS) / TIANA KHASI (AUS) / YUNG SAMMY (NG/IND) / MAYA LYNGDOH /
          YASHRAJ / ISHAN (AUS) / Murder in Space / The Dixie Boys / MOOKHURI / Kim the
          Beloved /
        </p>
        <p>
          <span className="stage">Electric Hills Stage(2024)</span>
          <br />
          LIS VEGAS (USA) / ROBU (IND/UK) / AIOM / BRIAN / WALTER / MEBAN /
          INSOWMYA / RASA / PENNY PLAN / SEV / CASSIDY GODWIN
        </p>
      </article>
      <div className="center-content">
        {/* Contact Us Button */}
        <button
          onClick={() => setIsContactModalOpen(true)}
          className="get-tickets-button"
        >
          <div className="button-label">
            CONTACT US <img src={vectorIcon} alt="" className="vector-icon" aria-hidden="true" />
          </div>
        </button>

        {/* Contact Modal */}
        <ContactModal 
          isOpen={isContactModalOpen} 
          onClose={() => setIsContactModalOpen(false)} 
        />

        {/* Artist Image Section */}
        <div className="artist-image">
          <img src={artistImage} alt="The Hills Festival 2024 artists performing" />
        </div>
      </div>
    </section>
      
  );
};

export default Lineup;
